import { isSameDay } from 'date-fns';

export const DEFAULT_START_TIME = '00:00';
export const DEFAULT_END_TIME = '23:59';

export function createTodayDateRange() {
  const today = new Date();
  return [{ startDate: today, endDate: today, key: 'selection' }];
}

export function isDefaultDateTimeRange(
  dateRange,
  startTime = DEFAULT_START_TIME,
  endTime = DEFAULT_END_TIME,
) {
  if (!Array.isArray(dateRange) || !dateRange[0]?.startDate || !dateRange[0]?.endDate) {
    return false;
  }
  const today = new Date();
  return (
    isSameDay(dateRange[0].startDate, today) &&
    isSameDay(dateRange[0].endDate, today) &&
    (startTime || DEFAULT_START_TIME) === DEFAULT_START_TIME &&
    (endTime || DEFAULT_END_TIME) === DEFAULT_END_TIME
  );
}
